import styled from 'styled-components';

export const PageContentBox = styled.div`
  height: 100%;
  display: flex;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  padding: ${(props) => props.theme.atlas.core.spacing[3]}
    ${(props) => props.theme.atlas.core.spacing[6]};
  gap: ${(props) => props.theme.atlas.core.spacing[4]};
  flex-direction: column;
`;
